import { Descendant } from 'slate';
import {
  SlateValue2MustacheV2,
  SlateValue2Mustache,
} from 'components/TemplateEditor/mustacheUtils';
import { hasScoreText } from './model';

/** Backend v2 protocol nests concept tokens inside text blocks. Keep the editor's Slate schema. */
export function serializeScoreNodes(nodes: Descendant[]): string {
  return (
    '#mustache#' +
    nodes
      .map((node) => {
        if (node.type !== 'paragraph') return SlateValue2MustacheV2([node]);
        if (!hasScoreText(node.children)) return '';
        const body = SlateValue2Mustache(node.children).replace(
          /\{\{#text\}\}([\s\S]*?)\{\{\/text\}\}/g,
          '$1',
        );
        return `{{#text}}${body}{{/text}}`;
      })
      .join('')
  );
}
export function scoreWireContext(
  value: Marketing.ExecuteContext<Descendant[]>,
): Marketing.ExecuteContext {
  return {
    content: serializeScoreNodes(value.content),
    translatedContent: hasScoreText(value.translatedContent)
      ? serializeScoreNodes(value.translatedContent)
      : '',
  };
}
